import { Dropdown } from 'primereact/dropdown';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ScoreCardFilter } from '../../components/scoreCardFilter/ScoreCardFilter';
import { useGetScorecardAgentsQuery } from '../../components/scoreCardFilter/scoreCardFilterSlice';
import StatusDetail from '../../components/scorecardRules/statusDetail/StatusDetail';
import { TimeCheck } from '../../components/timeCheck/TimeCheck';
import ScoreCardRoles from '../../features/compensation/scoreCardRoles/ScoreCardRoles';
import { Disputes } from '../../features/scorecardRulesAndActivity/disputes/Disputes';
import { PayRulesQualifiers } from '../../features/scorecardRulesAndActivity/payRulesQualifiers/PayRulesQualifiers';
import { PayoutAging } from '../../features/scorecardRulesAndActivity/payoutAging/PayoutAging';
import { ScorecardApprovalActivity } from '../../features/scorecardRulesAndActivity/scorecardApprovalActivity/ScorecardApprovalActivity';
import { ScorecardPayRules } from '../../features/scorecardRulesAndActivity/scorecardPayRules/ScorecardPayRules';
import { ScorecardPayoutCriteria } from '../../features/scorecardRulesAndActivity/scorecardPayoutCriteria/ScorecardPayoutCriteria';
import { ScorecardRulesHeader } from '../../features/scorecardRulesAndActivity/scorecardRulesHeader/ScorecardRulesHeader';
import { selectCurrentUser } from '../login/authSlice';
import './scorecardRulesAndActivity.scss';
import EDSCompAssignment from '../../components/edsCompAssignment/EdsCompAssignment';

const PayoutAgingTabIndex = 4;

export const ScorecardRulesAndActivity = () => {
    const loggedUser = useSelector(selectCurrentUser);
    const [agentNumber, setAgentNumber] = useState<any>();
    const [inputMonth, setMonth] = useState(new Date().getMonth() + 1);
    const [inputYear, setYear] = useState(new Date().getFullYear());
    const [filterDisabled, setFilterDisable] = useState<boolean>(false);
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [inputScorecardVersion, setInputScorecardVersion] = useState(0);
    const [scorecardId, setScorecardId] = useState<string | number>('');
    const [scoreCardName, setScoreCardName] = useState('');
    const [agentName, setAgentName] = useState('');
    const [employeeNumber, setEmployeeNumber] = useState<number>();
    const [employeeRole, setEmployeeRole] = useState<number>();
    const [scorecardAgents, setScorecardAgents] = useState<any>([]);
    const [inputScorecardForDisputes, setInputScorecardForDisputes] = useState<number>();
    const [inputScorecardId, setInputScorecardId] = useState<any>();
    const [inputParentClientId, setInputParentClientId] = useState<any>();
    const { data: scorecardAgentsData } = useGetScorecardAgentsQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );
    console.log(agentNumber, inputMonth, inputYear, inputScorecardVersion, scoreCardName, agentName);

    const onScoreCardChange = (value: any) => {
        if (value !== undefined && value !== '' && value !== null) {
            setMonth(value.month);
            setYear(value.year);
            setInputScorecardVersion(value.scorecardVersionId);
            //setDate(value.currentDate);
            setScoreCardName(value.scorecardName);
            setScorecardId(value.scorecardId);
        } else {
            setScorecardId('');
        }
    };
    const EmployeeOnChange = (e: any) => {
        setEmployeeNumber(e.value);
        const employeeRole = scorecardAgents?.filter((ele: any) => {
            return ele.agent_number === e.value;
        });
        setEmployeeRole(employeeRole[0]?.scorecard_role_id);
    };
    useEffect(() => {
        setEmployeeNumber(undefined);
        setEmployeeRole(undefined);
        if (scorecardAgentsData?.data?.length > 0) {
            setScorecardAgents(scorecardAgentsData?.data);
        } else {
            setScorecardAgents([]);
        }
    }, [scorecardAgentsData]);
    useEffect(() => {
        setInputScorecardForDisputes(undefined);
    }, [inputScorecardVersion]);
    useEffect(() => {
        setFilterDisable(false);
    }, [activeIndex]);
    const onAgentNameChange = (e: any) => {
        setAgentName(e);
    };

    return (
        <div>
            <div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-4 text-start">
                            <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                {`Hello ${loggedUser}!`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            {activeIndex !== PayoutAgingTabIndex && (
                <div className="card shadow bg-body rounded mt-3 border-0">
                    <div className="card-body p-3">
                        <div className="row">
                            <ScoreCardFilter
                                filterDisabled={filterDisabled}
                                menuName={'ScorecardRules'}
                                agentNumber={setAgentNumber}
                                scorecardData={onScoreCardChange}
                                agentName={onAgentNameChange}
                                filterSCValue={setInputScorecardVersion}
                                // filterSCName={setScoreCardName}
                                filterMonth={setMonth}
                                filterYear={setYear}
                                // filterAgentNumber={setAgentNumber}
                                scorecardId={setInputScorecardId}
                                parentClientId={setInputParentClientId}
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => {
                                    if (e.index === PayoutAgingTabIndex) {
                                        setScorecardId('');
                                    }
                                    setActiveIndex(e.index);
                                }}
                            >
                                <TabPanel header="Approval Activity">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <ScorecardApprovalActivity
                                                inputmonth={inputMonth}
                                                inputyear={inputYear}
                                                scorecardVersion={setInputScorecardForDisputes}
                                                activeIndexForTab={setActiveIndex}
                                                scorecardId={scorecardId}
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                                {/* NOT PRODUCTION READY */}
                                <TabPanel header="Disputes">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <Disputes
                                                inputMonth={inputMonth}
                                                inputYear={inputYear}
                                                inputScorecardVersionId={inputScorecardVersion}
                                                scorecardVersionIdFromDisputes={inputScorecardForDisputes}
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header="Payout Criteria">
                                    <div className="card border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <ScorecardPayoutCriteria
                                                inputmonth={inputMonth}
                                                inputyear={inputYear}
                                                inputScorecardVersion={inputScorecardVersion}
                                            />
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel header="Scorecard Rules">
                                    <div className="row mt-3">
                                        <div className="col-md-2">
                                            <Dropdown
                                                value={employeeNumber}
                                                options={scorecardAgents}
                                                optionLabel="agent_name"
                                                optionValue="agent_number"
                                                onChange={EmployeeOnChange}
                                                className="custom-dropdown mb-2"
                                                placeholder="Select the Agent"
                                            />
                                        </div>
                                    </div>
                                    <div className="card  border-0 p-3 ps-0">
                                        <div className="card-body p-0">
                                            <div className="row">
                                                <div className="col-md-2">
                                                    <PayRulesQualifiers
                                                        inputMonth={inputMonth}
                                                        inputYear={inputYear}
                                                        inputScorecardVersion={inputScorecardVersion}
                                                        inputEmployeeNumber={employeeNumber}
                                                    />
                                                </div>
                                                <div className="col-md-5">
                                                    <ScorecardPayRules
                                                        inputEmployeeNumber={employeeNumber}
                                                        inputYear={inputYear}
                                                        inputMonth={inputMonth}
                                                        inputScorecardVersion={inputScorecardVersion}
                                                        inputScorecardRoleId={employeeRole}
                                                    />
                                                </div>
                                                <div className="col-md-3">
                                                    <StatusDetail
                                                        inputYear={inputYear}
                                                        inputMonth={inputMonth}
                                                        inputScorecardVersion={inputScorecardVersion}
                                                    />
                                                </div>
                                                <div className="col-md-2 ">
                                                    <ScoreCardRoles
                                                        inputMonth={inputMonth}
                                                        inputYear={inputYear}
                                                        inputScorecardVersion={inputScorecardVersion}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card shadow bg-body rounded mt-4 border-0">
                                        <ScorecardRulesHeader
                                            inputYear={inputYear}
                                            inputMonth={inputMonth}
                                            scorecardVersionId={inputScorecardVersion}
                                        />
                                    </div>
                                </TabPanel>
                                    <TabPanel header="Payout Aging">
                                        <PayoutAging
                                            scorecardVersion={setInputScorecardForDisputes}
                                            activeIndexForTab={setActiveIndex}
                                            scorecardId={scorecardId}
                                        />
                                    </TabPanel>
                                
                                <TabPanel header="Time Check">
                                    <TimeCheck
                                        inputMonth={inputMonth}
                                        inputYear={inputYear}
                                    />
                                </TabPanel>                                
                                    <TabPanel header="EDS and Compensation Assignment">
                                        <EDSCompAssignment agentNumber={agentNumber} agentName={agentName} scorecardId={inputScorecardId} parentClientId={inputParentClientId}
                                        />
                                    </TabPanel>             
                            </TabView>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
